import { Tag } from "antd";
import { Button } from "components/Button";
import FilterInput from "components/Form/filterInput";
import { format } from "date-fns";
import { useCallback,useEffect,useState } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { toTitleCase } from "utils/common";
import { leaveStatusOptions } from "utils/constants";
import { namesFor } from "components/Form/filterValues";
const EmployeeLeaveFilter = ({
  handleFilterDrawer,
  filters,
  handleInputChange,
  searchPlaceholder,
  handleFilterChange,
  loading,
  leaveTypes,
  appliedFilterCount,
}) => {
  const { userData, userDataLoading } = useSelector((state) => state.common);
  const [searchParams, setSearchParams] = useSearchParams();

  const [appliedFilters, setAppliedFilters] = useState([]);

  const setInputValue = useCallback(
    (key) => {
      if (filters.length) {
        let selectedValue = [...filters].find((item) => item.key === key);
        return selectedValue?.value;
      } else {
        return "";
      }
    },
    [filters]
  );

  useEffect(() => {
    if (!userDataLoading) {
      console.log(filters, "LLLs");
      let _appliedFilters = [...filters].map((item) => {
        let label = "";
        let value = "";
        switch (item.key) {
          case "approval_status":
            let approval_status = toTitleCase(
              searchParams.get("approval_status") || ""
            );
            let selected_status = [...leaveStatusOptions].find(
              (item) => item.value == approval_status || ""
            );
            value = approval_status;
            label = "Approval status";
            break;
          case "search":
            value = toTitleCase(searchParams.get("search") || "");
            label = "Search term";
            break;
          case "reference_date":
            let ref_date = toTitleCase(
              searchParams.get("reference_date") || ""
            );
            let formatted_ref_date = "";
            if (ref_date) {
              formatted_ref_date = format(
                searchParams.get("reference_date"),
                "yyyy-MM-dd"
              );
            }
            value = formatted_ref_date;
            label = "Reference date";
            break;
          case "posting_date":
            let post_date = toTitleCase(searchParams.get("posting_date") || "");
            let formatted_post_date = "";
            if (post_date) {
              formatted_post_date = format(
                searchParams.get("posting_date"),
                "yyyy-MM-dd"
              );
            }
            value = formatted_post_date;
            label = "Posting date";
            break;
          case "company_user":
            value = namesFor(searchParams.get("company_user") || "", userData, u => u.id, u => `${u.first_name} ${u.last_name || ""}`.trim());
            label = "Employee";
            break;
          case "current_approver":
            value = namesFor(searchParams.get("current_approver") || "", userData, u => u.id, u => `${u.first_name} ${u.last_name || ""}`.trim());
            label = "Current approver";
            break;
          default:
            label = "";
            value = "";
        }
        return {
          ...item,
          value,
          label,
        };
      });

      setAppliedFilters(
        _appliedFilters.filter((item) => item.value && item.key != "search")
      );
    }
  }, [userData, searchParams, leaveStatusOptions]);

  const handleClose = (e, item) => {
    console.log(item, "llll");
    e.preventDefault();
    if (
      item.key == "search" ||
      item.key == "reference_date" ||
      item.key == "posting_date"
    ) {
      handleInputChange("", item.key, true);
    } else {
      handleFilterChange("", item.key, true);
    }
  };
  return (
    <div>
      <div className="row filter-row mb-4">
        <div className="col-10">
          <div className="row" >
          <div className="col-sm-12 col-lg-4  ">
            <FilterInput
              defaultValue={setInputValue("search")}
              onChange={(e) => {
                handleInputChange(e.target.value, "search", true);
              }}
              id="search"
              label={searchPlaceholder}
            />
          </div>
          <div className="col-sm-12  col-lg-8  mt-1 flex-wrap">
            {appliedFilters.map((item) => {
              return (
                <Tag
                  icon={
                    loading && (
                      <i
                        class="fas fa-spinner fa-spin me-1"
                        aria-hidden="true"
                      ></i>
                    )
                  }
                  className="mb-1"
                  color={"red"}
                  closable closeIcon={<i class="fa fa-times" aria-hidden="true"></i>}
                  onClose={(e) => handleClose(e, item)}
                >
                  {item?.label}
                  {item.label && " : "}
                  {item?.value}
                </Tag>
              );
            })}
          </div>
          </div>
         
        </div>

        <div className="col-2 d-flex justify-content-end" style={{ paddingRight: 0 }}>
          <div className="view-icons position-relative">
            <Button
              onClick={handleFilterDrawer}
              icon="las la-filter"
              // id="collapse-header"
              className="list-view btn btn-link position-relative"
            />

            {appliedFilterCount ? (
              <span
                className="badge bg-danger position-absolute"
                style={{
                  top: "5px",
                  right: "5px",
                  transform: "translate(50%, -50%)",
                }}
              >
                {appliedFilterCount}
              </span>
            ) : (
              <div />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeLeaveFilter;
